var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.data && _vm.data.did) || (_vm.arrData && _vm.arrData.length > 0)
    ? _c("div", { staticClass: "lite_select_view" }, [
        _vm.data && _vm.data.did
          ? _c("div", { staticClass: "lite_select_view_box" }, [
              _c("div", {
                class:
                  "drive-icon drive-icon-" + _vm.getDrive(_vm.data.did).type
              }),
              _vm._v(" "),
              _c("div", { staticClass: "lite_select_view_path" }, [
                _vm._v(
                  _vm._s(
                    _vm.getDrive(_vm.data.did).name +
                      _vm.getNodePath(_vm.data.node)
                  )
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.arrData && _vm.arrData.length == 1
          ? _c("div", { staticClass: "lite_select_view_box" }, [
              _c("div", {
                class:
                  "drive-icon drive-icon-" +
                  _vm.getDrive(_vm.arrData[0].did).type
              }),
              _vm._v(" "),
              _c("div", { staticClass: "lite_select_view_path" }, [
                _vm._v(
                  _vm._s(
                    _vm.getDrive(_vm.arrData[0].did).name +
                      _vm.getNodePath(_vm.arrData[0].node)
                  )
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.arrData && _vm.arrData.length > 1
          ? _c(
              "div",
              { staticClass: "lite_select_list myscroll" },
              _vm._l(_vm.arrData, function(item, index) {
                return _c(
                  "div",
                  {
                    key: item.did + (item.node ? item.node.id : ""),
                    staticClass: "lite_select_list_item"
                  },
                  [
                    item.node
                      ? _c("img", {
                          staticClass: "select-node-icon",
                          attrs: {
                            src: "/static/file/" + item.node.icon + ".svg"
                          },
                          on: {
                            error: function(e) {
                              return (e.target.src = "/static/file/file.svg")
                            }
                          }
                        })
                      : _c("div", {
                          class:
                            "drive-icon drive-icon-" +
                            _vm.getDrive(item.did).type
                        }),
                    _vm._v(" "),
                    _c("div", { staticClass: "lite_select_view_path" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getDrive(item.did).name +
                            _vm.getNodePath(item.node)
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "lite_select_view_close",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.removeItem(index)
                        }
                      }
                    })
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1868c5c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1868c5c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_select_view.vue
// module id = null
// module chunks = 